module.exports = __webpack_public_path__ + "static/media/domain_logo_Africa.c17d7ba2.svg";